module.exports = __webpack_public_path__ + "static/media/china.086d77a5.svg";